import { Toaster } from "components/notification/Toaster";
import useAccountControlActions from "dataflow/billingPortal/actions/useAccountControl.actions";
import useOutletsActions from "dataflow/billingPortal/actions/useOutlet.actions";
import { isArrayEmpty, isArrayNotEmpty, isDateValid, isNumberOrStringValid, isStringTrimEmpty } from "functions";
import { useCustomSelector } from "hooks";
import { useEffect, useRef, useState } from "react";


export default function useFilters() {
    const [performedDate_from, setPerformedDate_from] = useState();
    const [performedDate_to, setPerformedDate_to] = useState();
    const [comId, setComId] = useState();
    const [outletIDs, setOutletIDs] = useState([]);
    const customerEmail = useRef();
    const systemRemark = useRef();
    const [isOutletListModalVisible, setIsOutletListModalVisible] = useState();

    const [isFiltering, setIsFiltering] = useState();
    const [isResetRequired, setIsResetRequired] = useState();

    const { getOutletLogs_requesting } = useCustomSelector("outlet");

    // Reset the reset
    useEffect(() => {
        if (isResetRequired) setIsResetRequired(false);
    }, [isResetRequired])

    // Get list of company IDs
    const { getAllComList } = useAccountControlActions();
    useEffect(() => {
        getAllComList();
    }, []);

    // Get list of outlets
    const { getAllOutlets } = useOutletsActions();
    useEffect(() => {
        if (comId) getAllOutlets(null, null, null, { comId: comId });
    }, [comId]);
    
    function onFilterSubmit(setFilterOptions, filterOptions = {}, isReset) {
        if (isReset) {
            setComId("");
            setOutletIDs([]);
            customerEmail.current = "";
            setPerformedDate_from("");
            setPerformedDate_to("");
            systemRemark.current = "";
            setIsResetRequired(true);
        }
        else if (isNumberOrStringValid(comId) && isDateValid(performedDate_from) && isDateValid(performedDate_to) &&
            isArrayNotEmpty(outletIDs)) {

            setIsFiltering(true);
            setFilterOptions({
                ...filterOptions,
                comId,
                startDate: performedDate_from,
                endDate: performedDate_to,
                customerEmail: customerEmail.current,
                outletIDs: outletIDs.map((id) => {
                    return {
                        outletID: id
                    }
                }),
                remark: systemRemark.current
            })
        }
        else {
            let filterType = "";
            if (isArrayEmpty(outletIDs)) {
                filterType = "Outlet(s)";
            }
            else if (!isDateValid(performedDate_from)) {
                filterType = "From Date";
            }
            else if (!isDateValid(performedDate_to)) {
                filterType = "To Date";
            }
            else if (!comId) {
                filterType = "COM ID";
            }

            Toaster({
                type: "info",
                msg: filterType + " filter input required"
            })
        }
    }

    useEffect(() => {
        if (!getOutletLogs_requesting) setIsFiltering(false);
    }, [getOutletLogs_requesting])
    
    return {
        performedDate_from, setPerformedDate_from,
        performedDate_to, setPerformedDate_to,
        comId, setComId,
        outletIDs, setOutletIDs,
        customerEmail, systemRemark,

        isResetRequired,
        isFiltering, onFilterSubmit,
        isOutletListModalVisible, setIsOutletListModalVisible
    }
}